// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"bfa5af5c","306":"d9e8e355","320":"b2838863","388":"53993619","500":"b5305b17","632":"31ab71fe","792":"68f2a7ef"}[chunkId] + ".chunk.js";
};